import { render, staticRenderFns } from "./DeliveryDetails.vue?vue&type=template&id=30a5dcf1&scoped=true"
import script from "./DeliveryDetails.vue?vue&type=script&lang=js"
export * from "./DeliveryDetails.vue?vue&type=script&lang=js"
import style0 from "./DeliveryDetails.vue?vue&type=style&index=0&id=30a5dcf1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30a5dcf1",
  null
  
)

export default component.exports